export const regionOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    menuWidth:380,
    // labelWidth: "150",
    defaultSort: {
      prop: "createTime",
      order: "descending",
    },
    column: [
      {
        label: "业务员名称",
        prop: "salesmanName",
        search: true,
      },
      {
        label: "区域名称",
        prop: "name",
      },
      {
        label: "创建人",
        prop: "createBy",
      },
    ],
  };
  